import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
// Core Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Programs } from './pages/Programs';
import { Schedule } from './pages/Schedule';
import { Instructors } from './pages/Instructors';
import { FreeClass } from './pages/FreeClass';
import { Contact } from './pages/Contact';
// Program Pages
import { BrazilianJiuJitsu } from './pages/programs/BrazilianJiuJitsu';
import { KidsBrazilianJiuJitsu } from './pages/programs/KidsBrazilianJiuJitsu';
import { MuayThai } from './pages/programs/MuayThai';
import { Boxing } from './pages/programs/Boxing';
import { Kickboxing } from './pages/programs/Kickboxing';
import { MMATraining } from './pages/programs/MMATraining';
import { PersonalTraining } from './pages/programs/PersonalTraining';
// City Pages
import { Redford } from './pages/cities/Redford';
import { Livonia } from './pages/cities/Livonia';
import { Detroit } from './pages/cities/Detroit';
import { FarmingtonHills } from './pages/cities/FarmingtonHills';
import { Southfield } from './pages/cities/Southfield';
import { DearbornHeights } from './pages/cities/DearbornHeights';
import { Westland } from './pages/cities/Westland';
import { GardenCity } from './pages/cities/GardenCity';
import { OakPark } from './pages/cities/OakPark';
import { BeverlyHills } from './pages/cities/BeverlyHills';
import { Farmington } from './pages/cities/Farmington';
import { Dearborn } from './pages/cities/Dearborn';
import { Novi } from './pages/cities/Novi';
import { Northville } from './pages/cities/Northville';
import { Plymouth } from './pages/cities/Plymouth';
import { RoyalOak } from './pages/cities/RoyalOak';
import { Ferndale } from './pages/cities/Ferndale';
import { Inkster } from './pages/cities/Inkster';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          {/* Core Routes */}
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="programs" element={<Programs data-id="element-9" />} data-id="element-8" />
          <Route path="schedule" element={<Schedule data-id="element-11" />} data-id="element-10" />
          <Route path="instructors" element={<Instructors data-id="element-13" />} data-id="element-12" />
          <Route path="free-class" element={<FreeClass data-id="element-15" />} data-id="element-14" />
          <Route path="contact" element={<Contact data-id="element-17" />} data-id="element-16" />

          {/* Program Routes */}
          <Route path="programs/brazilian-jiu-jitsu" element={<BrazilianJiuJitsu data-id="element-19" />} data-id="element-18" />
          <Route path="programs/kids-brazilian-jiu-jitsu" element={<KidsBrazilianJiuJitsu data-id="element-21" />} data-id="element-20" />
          <Route path="programs/muay-thai" element={<MuayThai data-id="element-23" />} data-id="element-22" />
          <Route path="programs/boxing" element={<Boxing data-id="element-25" />} data-id="element-24" />
          <Route path="programs/kickboxing" element={<Kickboxing data-id="element-27" />} data-id="element-26" />
          <Route path="programs/mma-training" element={<MMATraining data-id="element-29" />} data-id="element-28" />
          <Route path="programs/personal-training" element={<PersonalTraining data-id="element-31" />} data-id="element-30" />

          {/* City Routes */}
          <Route path="cities/redford" element={<Redford data-id="element-33" />} data-id="element-32" />
          <Route path="cities/livonia" element={<Livonia data-id="element-35" />} data-id="element-34" />
          <Route path="cities/detroit" element={<Detroit data-id="element-37" />} data-id="element-36" />
          <Route path="cities/farmington-hills" element={<FarmingtonHills data-id="element-39" />} data-id="element-38" />
          <Route path="cities/southfield" element={<Southfield data-id="element-41" />} data-id="element-40" />
          <Route path="cities/dearborn-heights" element={<DearbornHeights data-id="element-43" />} data-id="element-42" />
          <Route path="cities/westland" element={<Westland data-id="element-45" />} data-id="element-44" />
          <Route path="cities/garden-city" element={<GardenCity data-id="element-47" />} data-id="element-46" />
          <Route path="cities/oak-park" element={<OakPark data-id="element-49" />} data-id="element-48" />
          <Route path="cities/beverly-hills" element={<BeverlyHills data-id="element-51" />} data-id="element-50" />
          <Route path="cities/farmington" element={<Farmington data-id="element-53" />} data-id="element-52" />
          <Route path="cities/dearborn" element={<Dearborn data-id="element-55" />} data-id="element-54" />
          <Route path="cities/novi" element={<Novi data-id="element-57" />} data-id="element-56" />
          <Route path="cities/northville" element={<Northville data-id="element-59" />} data-id="element-58" />
          <Route path="cities/plymouth" element={<Plymouth data-id="element-61" />} data-id="element-60" />
          <Route path="cities/royal-oak" element={<RoyalOak data-id="element-63" />} data-id="element-62" />
          <Route path="cities/ferndale" element={<Ferndale data-id="element-65" />} data-id="element-64" />
          <Route path="cities/inkster" element={<Inkster data-id="element-67" />} data-id="element-66" />
        </Route>
      </Routes>
    </BrowserRouter>;
}